/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPipeline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m21.766 2-.94 1.566-.337.591c-.168.3-.35.634-.543.998l-.345.663a57.513 57.513 0 0 0-1.682 3.576c-1.141 2.663-2.01 5.267-2.494 7.691C15.145 18.482 15 19.793 15 21v1H9v-1c0-1.207-.146-2.518-.425-3.915-.485-2.424-1.353-5.028-2.494-7.691a57.62 57.62 0 0 0-2.027-4.239l-.143-.267a49.457 49.457 0 0 0-.272-.5l-.25-.45a30.6 30.6 0 0 0-.176-.304L2.233 2zm-8.53 16.001h-2.471c.1.675.17 1.332.205 1.971l.001.028h2.057l.039-.555c.039-.471.095-.953.168-1.444zm1.194-5H9.57c.324 1.017.599 2.019.82 3h3.22c.221-.981.496-1.983.82-3zM16.345 8h-8.69l.264.606c.344.803.665 1.603.96 2.395h6.242A52.702 52.702 0 0 1 16.345 8zm1.95-4H5.704l.117.22c.303.571.605 1.165.904 1.778L17.274 6c.299-.613.602-1.208.905-1.78z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPipeline as Pipeline };
